/**
 * lihaibin  20160420/  东财活动页面统一分享
 * emH5.Share({ 
 *      title: "真送钱！东方财富送你5元现金红包！无门槛！可提现！", 
 *      desc: "热烈祝贺东方财富证券重磅来袭！", 
 *      link: "https://cps.eastmoney.com/Extension/Ttjj/FiveRed", 
 *      imgUrl: "https://cps.eastmoney.com/Extension/images/FiveRed.jpg" 
 * });
 */
var emH5 = window.emH5 || {};
emH5.version = '1.1.0';
window.emH5 = emH5;
//分享设置
emH5.ShareData = {
    title: document.title,
  //  desc: $("meta[name=description]").attr("content"),
    link: window.location.href,
    imgUrl: '',
    fail: function (res) {
        alert(JSON.stringify(res));
    }
}
emH5.isios = function () {
    var isIOS = false;
    if (/(iPhone|iPod|iPad|iTouch|iOS)/i.test(navigator.userAgent)) {
        isIOS = true;
    }
    return isIOS;
}
emH5.Share = function (options) {
   /*
    emH5.ShareData = $.extend(emH5.ShareData, options);
    var _url = window.location.href;
    $.getScript((_url[4] == 's' ? "https" : "http") + "://res.wx.qq.com/open/js/jweixin-1.1.0.js", function () {
        $.getJSON((_url[4] == 's' ? "https" : "http") + "://cps.eastmoney.com/emweixin/WX/GetJsSdkUiPackage/3?s=" + encodeURIComponent(_url) + "&cb=?", function (data) {
            wx.config({
                debug: false,
                appId: data.AppId,
                timestamp: data.Timestamp,
                nonceStr: data.NonceStr,
                signature: data.Signature,
                jsApiList: [
                    'checkJsApi',
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'onMenuShareQQ',
                    'onMenuShareWeibo'
                ]
            });
            wx.ready(function () {
                wx.onMenuShareAppMessage(emH5.ShareData);
                wx.onMenuShareTimeline(emH5.ShareData);
                wx.onMenuShareQQ(emH5.ShareData);
                wx.onMenuShareWeibo(emH5.ShareData);
            });
        });
    });
    window.emH5ShareInfo = function () {
        var jsonfx = '{ "callbackname":"cb_share","type": "all","title": "' + emH5.ShareData.title + '","img": "' + emH5.ShareData.imgUrl + '","url": "' + emH5.ShareData.link + '", "desc": "' + emH5.ShareData.desc + '"}';
        if (emH5.isios()) {
            window.location = "onwebshareclicked:" + jsonfx;
        }
        else if (window.eastmoney) {
            eastmoney.onShareClicked(jsonfx);
        }
    }*/
}



// WEBPACK FOOTER //
// ./src/utils/emH5Share.js